import React, { useState, useRef, useEffect, useContext } from 'react'
import { useForm, Controller } from "react-hook-form";

import AppContext from '../../contexts/AppContext'
import Breadcrumbs from '../Breadcrumbs'
import Header from '../Header'
import Footer from '../Footer'
import { breadcrumbsBy, locationSearchCity } from '../../services/locations'
import { getIndustries, getBusinessTypes } from '../../services/companies'

import useToastContext from "../../hooks/useToastContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faGlobe, faUpload, faCloudUploadAlt, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'
import { Helmet } from "react-helmet-async";
import { AsyncTypeahead } from 'react-bootstrap-typeahead'

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const days = [
    { day: 'monday', label: 'Monday'  },
    { day: 'tuesday', label: 'Tuesday'  },
    { day: 'wednesday', label: 'Wednesday'  },
    { day: 'thursday', label: 'Thursday'  },
    { day: 'friday', label: 'Friday'  },
    { day: 'saturday', label: 'Saturday'  },
    { day: 'sunday', label: 'Sunday'  },
]

const times = [ '12:00 AM', '12:30 AM', '1:00 AM', '1:30 AM', '2:00 AM', '2:30 AM', '3:00 AM', '3:30 AM', '4:00 AM', '4:30 AM', '5:00 AM', '5:30 AM', '6:00 AM', '6:30 AM', '7:00 AM', '7:30 AM', '8:00 AM', '8:30 AM', '9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM', '5:00 PM', '5:30 PM', '6:00 PM', '6:30 PM', '7:00 PM', '7:30 PM', '8:00 PM', '8:30 PM', '9:00 PM', '9:30 PM', '10:00 PM', '10:30 PM', '11:00 PM', '11:30 PM' ]

const LinksForm = ({ title, links, onSubmit }) => {

    const [ type, setType ] = useState('')
    const [ url, setUrl  ] = useState('')
    const [ errors, setErrors ] = useState({})
    const [ loading, setLoading ] = useState(false)

    const canAdd = true// type && url ? true : false

    const keyBy = items => items.map(item => item.url).join('-')

    const submit = items => {
        setLoading(true)
        setErrors({})
        onSubmit({links: items}).then(res => {
            setType('')
            setUrl('')
            setLoading(false)
            setLinks(items)
        }).catch(err => {
            const _errors = {}
            for(const key in (err.errors ? err.errors : {})){
                if(key.includes('.url')){
                    _errors.url = [...err.errors[key], ...(_errors.url ? _errors.url : [])].filter((v, i, a) => a.indexOf(v) === i)
                }
                if(key == 'links'){
                    _errors.url = [...err.errors[key], ...(_errors.url ? _errors.url : [])].filter((v, i, a) => a.indexOf(v) === i)
                }
                if(key.includes('.type')){
                    _errors.type = [...err.errors[key], ...(_errors.type ? _errors.type : [])].filter((v, i, a) => a.indexOf(v) === i)
                }

            }
            setErrors(_errors)
            setLoading(false)
        })
    }

    const addLink = () => {
        submit([...(links ? links : []), {type, url}])
    }

    const deleteLink = url => {
        submit(links.filter(item => item.url != url))
    }

    return (
        <div className="">
            <h4 className="card-title">
                Links for your verified business
            </h4>
            <div className="alert alert-warning">
                <FontAwesomeIcon icon={faExclamationTriangle} className="me-1" />
                These links are visible on your profile page and contact info dialog on your ad page if your business is verified or you place a <a href="/article/backlinks" target="_blank">backlink to AdSitePro.com website</a>. Or use the promote feature to place links for your ads.
            </div>
            <div className="mb-3">
                <div className="d-block d-sm-flex ">
                    <div className="flex-shrink-0 mb-1">
                        <select
                            value={type ? type : ''} onChange={e => setType(e.target.value)}
                            className={'form-select' + (errors.type ? ' is-invalid' : '')}
                        >
                            <option value="">Choose Link Type</option>
                            <option value="facebook">Facebook</option>
                            <option value="twitter">Twitter</option>
                            <option value="instagram">Instagram</option>
                            <option value="youtube">YouTube</option>
                            <option value="website">Website</option>
                        </select>
                        {errors.type && <div className="invalid-feedback d-block">{errors.type.join(' ')}</div>}
                    </div>
                    <div className="flex-grow-1 mx-sm-2 mb-1">
                        <input
                            name={type}
                            value={url}
                            onChange={e => setUrl(e.target.value)}
                            placeholder="Type URL, Example: https://www.facebook.com/mybusiness"
                            className={'form-control' + (errors.url ? ' is-invalid' : '')}
                        />
                        {errors.url && <div className="invalid-feedback d-block">{errors.url.join(' ')}</div>}
                    </div>
                    <div className="flex-shrink-0 mb-1">
                        <button
                            disabled={!canAdd}
                            className="btn btn-primary"
                            onClick={addLink}
                        >   {loading && <FontAwesomeIcon icon={faSpinner} spin />}
                            {!loading && 'Add'}
                        </button>
                    </div>
                </div>
            </div>
            {links &&
                <ul className="list-group list-group-flush overflow-hidden">
                    {links.map((link, key) =>
                        <li key={key} className="list-group-item d-flex flex-wrap justify-content-between px-0">
                            <span>
                                <span className="me-2">
                                    <FontAwesomeIcon
                                        icon={
                                            link.type == 'facebook' ? faFacebook
                                            : link.type == 'twitter' ? faTwitter
                                            : link.type == 'youtube' ? faYoutube
                                            : link.type == 'instagram' ? faInstagram
                                            : faGlobe
                                        }
                                    />
                                </span>
                                <a href={link.url} target="_blank">{link.url}</a>
                            </span>
                            <span>
                                <button
                                    className="btn btn-sm btn-outline-danger"
                                    disabled={loading}
                                    onClick={e => {
                                        e.stopPropagation()
                                        deleteLink(link.url)
                                    }}
                                >
                                    Delete
                                </button>
                            </span>
                        </li>
                    )}
                </ul>
            }
        </div>
    )
}

const BusinessProfileForm = ({ title, company, onSubmit }) => {

    const [ locations, setLocations ] = useState([])
    const [ loading, setLoading ] = useState(false)
    const [ submitting, setSubmitting ] = useState(false)
    const [ industries, setIndustries ] = useState([])
    const [ businessTypes, setBusinessTypes ] = useState([])

    const { register, watch, setError, errors, reset, control, handleSubmit, setValue } = useForm({
        defaultValues: company
    })

    const _onSubmit = data => {
        setSubmitting(true)
        onSubmit(data).then(res => {
            setSubmitting(false)
        }).catch(err => {
            setSubmitting(false)
            if(err.errors) {
                const keys = Object.keys(err.errors)
                for(var i = 0; i < keys.length; i ++){
                    setError(keys[i], { type: "manual", message: err.errors[keys[i]].join('. ')})
                }
            }
        })
    }

    const same_as = watch('address.same_as')
    const licensed = watch('licensed')
    const industry_id = watch('industry_id') ? String(watch('industry_id')) : ''

    useEffect(() => {
        getIndustries().then(res => {
            setIndustries(res)
        }).catch(err => console.log(err))
    }, [])

    useEffect(() => {
        if(industry_id){
            if(businessTypes.filter(item => item.industry_id = industry_id).length == 0){
                setValue('business_type_id', '')
            }
            getBusinessTypes(industry_id).then(res => {
                setBusinessTypes(res)
            }).catch(err => console.log(err))
        }else{
            setValue('business_type_id', '')
        }
    }, [ industry_id ])

    return (
        <div className="card mb-3">
            <div className="card-body">
                <div className="alert alert-info">
                    This information is not visible to the public but is used for administration verification.
                </div>

                <div className="mb-3">
                    <Controller
                        control={control}
                        name="licensed"
                        render={(
                            { onChange, onBlur, value, name, ref },
                            { invalid, isTouched, isDirty, error }
                        ) => (
                            <div className="d-flex flex-wrap">
                                <div className="form-check me-2">
                                    <input
                                        type="radio"
                                        onChange={() => onChange(true)}
                                        className="form-check-input"
                                        disabled={submitting}
                                        checked={value === true}
                                        id="licensed_checkbox_id"
                                    />
                                    <label
                                        className="form-check-label me-2"
                                        htmlFor="licensed_checkbox_id"
                                    >
                                        <span className="me-2">Licensed</span>
                                    </label>
                                </div>

                                <div className="form-check me-2">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        disabled={submitting}
                                        onChange={() => onChange(false)}
                                        checked={value === false}
                                        id="unlicensed_checkbox_id"
                                    />
                                    <label
                                        className="form-check-label me-2"
                                        htmlFor="unlicensed_checkbox_id"
                                    >
                                        <span className="me-2">Unlicensed</span>
                                    </label>
                                </div>

                                {value === null && <div className="text-danger">(required)</div>}
                            </div>
                        )}
                    />

                    {licensed !== null &&
                        <p>
                            {licensed === true && <span>Fill out this information and it will be reviewed to verify your business. <b>This will not be shown on your ad page</b>.</span>}
                            {licensed === false && <span>You will not have a verified business ad with this selection.</span>}
                        </p>
                    }

                    {errors.licensed && <div className="invalid-feedback d-block">{errors.licensed?.message}</div>}
                </div>

                <h4 className="card-title">{title ? title : (licensed ? 'Business Licence Registration Information' : 'Business Information')}</h4>

                <form onSubmit={handleSubmit(_onSubmit)}>

                    {licensed &&
                        <div className="row row-gap-small">
                            <div className="col-md-8 col-gap-small">
                                <div className="form-group">
                                    <label className="text-danger">
                                        <span className="me-3">In what city, state, country, province, township or?</span>
                                        <span>(Where did you register this license at?)<sup>*</sup></span>
                                    </label>
                                    <input
                                        name="license_city" ref={register}
                                        className={'form-control' + (errors.license_city ? ' is-invalid' : '')}
                                        placeholder=""
                                    />
                                    {errors.license_city && <div className="invalid-feedback d-block">{errors.license_city.message}</div>}
                                </div>
                            </div>
                            <div className="col-md-4 col-gap-small">
                                <div className="form-group">
                                    <label className="text-danger">On what date?<sup>*</sup></label>
                                    <input
                                        name="license_city_date" ref={register} type="date"
                                        className={'form-control' + (errors.license_city_date ? ' is-invalid' : '')}
                                    />
                                    {errors.license_city_date && <div className="invalid-feedback d-block">{errors.license_city_date.message}</div>}
                                </div>
                            </div>
                        </div>
                    }

                    {licensed &&
                        <div className="row row-gap-small">
                            <div className="col-md-5 col-gap-small">
                                <div className="form-group">
                                    <label className="text-danger">
                                        <abbr title="Business Licence Regisgration/Number/Certification Information">Business Licence Regisgration Information<sup>*</sup></abbr>
                                    </label>
                                    <input
                                        name="license" ref={register}
                                        className={'form-control' + (errors.license ? ' is-invalid' : '')}
                                        placeholder=""
                                    />
                                    {errors.license && <div className="invalid-feedback d-block">{errors.license.message}</div>}
                                </div>
                            </div>
                            <div className="col-md-3 col-gap-small">
                                <div className="form-group">
                                    <label>
                                        Tax ID number / EIN number
                                    </label>
                                    <input
                                        name="tin_ein" ref={register}
                                        className={'form-control' + (errors.tin_ein ? ' is-invalid' : '')}
                                        placeholder=""
                                    />
                                    {errors.tin_ein && <div className="invalid-feedback d-block">{errors.tin_ein.message}</div>}
                                </div>
                            </div>
                            <div className="col-md-2 col-gap-small">
                                <div className="form-group">
                                    <label>Beginning date</label>
                                    <input
                                        name="beginning_on" ref={register} type="date"
                                        className={'form-control' + (errors.beginning_on ? ' is-invalid' : '')}
                                    />
                                    {errors.beginning_on && <div className="invalid-feedback d-block">{errors.beginning_on.message}</div>}
                                </div>
                            </div>
                            <div className="col-md-2 col-gap-small">
                                <div className="form-group">
                                    <label>
                                        Expiration date
                                    </label>
                                    <input
                                        name="expiration_on" ref={register} type="date"
                                        className={'form-control' + (errors.expiration_on ? ' is-invalid' : '')}
                                    />
                                    {errors.expiration_on && <div className="invalid-feedback d-block">{errors.expiration_on.message}</div>}
                                </div>
                            </div>
                        </div>
                    }

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                {licensed ?
                                    <label className="text-danger">
                                        Legal <b>Business</b> Name On Licence
                                        <sup>*</sup>
                                    </label>
                                :
                                    <label className="text-danger">Your Business Name <sup>*</sup></label>
                                }
                                <input
                                    name="name" ref={register}
                                    placeholder=""
                                    className={'form-control' + (errors.name ? ' is-invalid' : '')}
                                />
                                {errors.name && <div className="invalid-feedback d-block">{errors.name.message}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                {licensed ? <label>Legal <b>Owner's</b> name on license</label> : <label>Owner's name</label>}
                                <input
                                    name="owner_name" ref={register}
                                    placeholder=""
                                    className={'form-control' + (errors.owner_name ? ' is-invalid' : '')}
                                />
                                {errors.owner_name && <div className="invalid-feedback d-block">{errors.owner_name.message}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8">
                            <div className="form-group">
                                {licensed ? <label className="text-danger">Business Address on License<sup>*</sup></label> : <label>Address</label>}
                                <input
                                    name="license_address.address" ref={register}
                                    className={'form-control' + (errors.license_address?.address ? ' is-invalid' : '')}
                                    placeholder=""
                                />
                                {errors.license_address?.address && <div className="invalid-feedback d-block">{errors.license_address.address.message}</div>}
                            </div>                            
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>APT/Condo/Suit #</label>
                                <input
                                    name="license_address.suit" ref={register}
                                    className={'form-control' + (errors.license_address?.suit ? ' is-invalid' : '')}
                                    placeholder=""
                                />
                                {errors.license_address?.suit && <div className="invalid-feedback d-block">{errors.license_address?.suit.message}</div>}
                            </div>                            
                        </div>
                    </div>                    

                    <div className="row">
                        <div className="col-md-8">
                            <div className="form-group">
                                {licensed ? <label className="text-danger">Location: City, State, Country, Province, Township or ?<sup>*</sup></label> : <label>Location: City, State, Country, Province, Township or ?</label>}
                                <Controller
                                    control={control}
                                    name="license_address.location"
                                    render={(
                                        { onChange, onBlur, value, name, ref },
                                        { invalid, isTouched, isDirty }
                                    ) => (
                                        <AsyncTypeahead
                                            id="business-profile-location-id"
                                            filterBy={() => true}
                                            isLoading={loading}
                                            labelKey={item => {
                                                return [item.name, item.location.name, item.location.location.name].join(', ')
                                            }}
                                            onSearch={query => {
                                                setLoading(true)
                                                locationSearchCity(query).then(res => {
                                                    setLocations(res)
                                                    setLoading(false)
                                                }).catch(() => setLoading(false))
                                            }}

                                            inputProps={{
                                                className: 'form-control' + (errors.license_address?.location ? ' is-invalid' : ''),
                                                placeholder: (value ? value.name : 'Type location name')
                                            }}
                                            onChange={selected => {
                                                const location = selected[0]
                                                if(location && location.id){
                                                    onChange({
                                                        id: location.id,
                                                        name: [location.name, location.location?.name, location.location?.location?.name].filter(item => item).join(', ')
                                                    })
                                                }else{
                                                    onChange(null)
                                                }
                                            }}
                                            options={locations}
                                        />
                                    )}
                                />
                                {errors.license_address?.location && <div className="invalid-feedback d-block">{errors.license_address?.location.message}</div>}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                {licensed ? <label className="text-danger">Zip Code<sup>*</sup></label> : <label>Zip Code</label>}
                                <input
                                    placeholder=""
                                    name="license_address.postal_code" ref={register}
                                    className={'form-control' + (errors.license_address?.postal_code ? ' is-invalid' : '')}
                                />
                                {errors.license_address?.postal_code && <div className="invalid-feedback d-block">{errors.license_address.postal_code.message}</div>}
                            </div>
                        </div>
                    </div>

                    {licensed ?
                        <div className="mb-3">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label className="text-danger">Business Owner's Live Phone Number<sup>*</sup></label>
                                        <Controller
                                            name="phone"
                                            control={control}
                                            defaultValue={null}
                                            render={(
                                                { onChange, onBlur, value, name, ref },
                                                { invalid, isTouched, isDirty }
                                            ) => (

                                                <PhoneInput
                                                    country={'us'}
                                                    placeholder=""
                                                    enableSearch={true}
                                                    isValid={(inputNumber, country) => {
                                                        return errors.phone ? false : true
                                                    }}
                                                    containerClass={errors.phone ? 'is-invalid' : ''}
                                                    inputStyle={errors.phone ? { borderColor: '#e3342f' } : {}}
                                                    buttonStyle={errors.phone ? { borderColor: '#e3342f' } : {}}
                                                    inputProps={{
                                                        className: 'w-100 form-control ' + (!errors.phone ? 'is-invalid' : '')
                                                    }}
                                                    value={value}
                                                    onChange={(value, country, e, formattedValue) => onChange(value)}
                                                />
                                            )}
                                        />
                                        {errors.phone &&
                                            <div className="invalid-custom-feedback">
                                                {errors.phone.message}
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="form-group">
                                        <label>Business Owner's Name</label>
                                        <input
                                            name="phone_owner_name" ref={register}
                                            placeholder=""
                                            className={'form-control' + (errors.phone_owner_name ? ' is-invalid' : '')}
                                        />
                                        {errors.phone_owner_name && <div className="invalid-feedback d-block">{errors.phone_owner_name.message}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                {licensed ? <label className="text-danger">Live Phone Number for Business<sup>*</sup></label> : <label>Live Phone Number for Business</label>}
                                <Controller
                                    name="business_phone"
                                    control={control}
                                    defaultValue={null}
                                    render={(
                                        { onChange, onBlur, value, name, ref },
                                        { invalid, isTouched, isDirty }
                                    ) => (

                                        <PhoneInput
                                            country={'us'}
                                            placeholder=""
                                            enableSearch={true}
                                            isValid={(inputNumber, country) => {
                                                return errors.business_phone ? false : true
                                            }}
                                            containerClass={errors.business_phone ? 'is-invalid' : ''}
                                            inputStyle={errors.business_phone ? { borderColor: '#e3342f' } : {}}
                                            buttonStyle={errors.business_phone ? { borderColor: '#e3342f' } : {}}
                                            inputProps={{
                                                className: 'w-100 form-control ' + (!errors.business_phone ? 'is-invalid' : '')
                                            }}
                                            value={value}
                                            onChange={(value, country, e, formattedValue) => onChange(value)}
                                        />
                                    )}
                                />
                                {errors.phone &&
                                    <div className="invalid-custom-feedback">
                                        {errors.phone.message}
                                    </div>
                                }
                            </div>
                        </div>
                    :
                        <div className="mb-3">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Business Owner's Live Phone Number</label>
                                        <Controller
                                            name="phone"
                                            control={control}
                                            defaultValue={null}
                                            render={(
                                                { onChange, onBlur, value, name, ref },
                                                { invalid, isTouched, isDirty }
                                            ) => (

                                                <PhoneInput
                                                    country={'us'}
                                                    placeholder=""
                                                    enableSearch={true}
                                                    isValid={(inputNumber, country) => {
                                                        return errors.phone ? false : true
                                                    }}
                                                    containerClass={errors.phone ? 'is-invalid' : ''}
                                                    inputStyle={errors.phone ? { borderColor: '#e3342f' } : {}}
                                                    buttonStyle={errors.phone ? { borderColor: '#e3342f' } : {}}
                                                    inputProps={{
                                                        className: 'w-100 form-control ' + (!errors.phone ? 'is-invalid' : '')
                                                    }}
                                                    value={value}
                                                    onChange={(value, country, e, formattedValue) => onChange(value)}
                                                />
                                            )}
                                        />
                                        {errors.phone &&
                                            <div className="invalid-custom-feedback">
                                                {errors.phone.message}
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Live Phone Number for Business</label>
                                        <Controller
                                            name="business_phone"
                                            control={control}
                                            defaultValue={null}
                                            render={(
                                                { onChange, onBlur, value, name, ref },
                                                { invalid, isTouched, isDirty }
                                            ) => (

                                                <PhoneInput
                                                    country={'us'}
                                                    placeholder=""
                                                    enableSearch={true}
                                                    isValid={(inputNumber, country) => {
                                                        return errors.business_phone ? false : true
                                                    }}
                                                    containerClass={errors.business_phone ? 'is-invalid' : ''}
                                                    inputStyle={errors.business_phone ? { borderColor: '#e3342f' } : {}}
                                                    buttonStyle={errors.business_phone ? { borderColor: '#e3342f' } : {}}
                                                    inputProps={{
                                                        className: 'w-100 form-control ' + (!errors.business_phone ? 'is-invalid' : '')
                                                    }}
                                                    value={value}
                                                    onChange={(value, country, e, formattedValue) => onChange(value)}
                                                />
                                            )}
                                        />
                                        {errors.phone &&
                                            <div className="invalid-custom-feedback">
                                                {errors.phone.message}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <div className="alert alert-danger">
                        <b>The information below is available publicly on your busines profile page.</b>
                    </div>

                    <div className="row">
                        {industries?.length > 0 &&
                            <div className="col-md-6">
                                <div className="form-group">
                                    {licensed ?
                                        <label htmlFor="businessIndustrySelect" className="text-danger">Business Industry<sup>*</sup></label>
                                    :
                                        <label htmlFor="businessIndustrySelect">Business Industry</label>
                                    }
                                    <Controller
                                        control={control}
                                        name="industry_id"
                                        render={(
                                            { onChange, onBlur, value, name, ref },
                                            { invalid, isTouched, isDirty, error }
                                        ) => (
                                            <select
                                                className={'form-select' + (errors.industry_id ? ' is-invalid' : '')}
                                                id="businessIndustrySelect"
                                                value={value ? value : ''}
                                                onChange={e => {
                                                    onChange(e.target.value)
                                                }}
                                            >
                                                <option value="">Select Industry</option>
                                                    {industries.map(item =>
                                                        <option key={item.id} value={item.id}>{item.name}</option>
                                                )}
                                            </select>
                                        )}
                                    />
                                    {errors.industry_id && <div className="invalid-feedback d-block">{errors.industry_id.message}</div>}
                                </div>
                            </div>
                        }

                        {businessTypes.length > 0 &&
                            <div className="col-md-6">
                                <div className="form-group">
                                    {licensed ?
                                        <label htmlFor="businessTypeSelect" className="text-danger">Business Type<sup>*</sup></label>
                                    :
                                        <label htmlFor="businessTypeSelect">Business Type</label>
                                    }
                                    <Controller
                                        control={control}
                                        name="business_type_id"
                                        render={(
                                            { onChange, onBlur, value, name, ref },
                                            { invalid, isTouched, isDirty, error }
                                        ) => (
                                            <select
                                                className={'form-select' + (errors.business_type_id ? ' is-invalid' : '')}
                                                value={value ? value : ''}
                                                onChange={e => {
                                                    onChange(e.target.value)
                                                }}
                                                id="businessTypeSelect"
                                            >
                                                <option value="">Select Business Type</option>
                                                {businessTypes.map(item =>
                                                    <option value={parseInt(item.id)} key={item.id}>{item.name}</option>
                                                )}
                                            </select>
                                        )}
                                    />
                                    {errors.business_type_id && <div className="invalid-feedback d-block">{errors.business_type_id.message}</div>}
                                </div>
                            </div>
                        }

                    </div>

                    <div className="form-group">
                        {licensed ?
                            <label className="text-danger">About you and your business<sup>*</sup></label>
                        :
                            <label>About you and your business</label>
                        }
                        <textarea
                            name="description"
                            placeholder=""
                            rows="5" ref={register}
                            className={'form-control' + (errors.description ? ' is-invalid' : '')}
                        ></textarea>
                        {errors.description && <div className="invalid-feedback d-block">{errors.description.message}</div>}
                    </div>

                    {licensed &&
                        <div>

                            <hr />

                            <div className="d-flex flex-wrap mb-2">
                                <h4 className={'card-title me-3 ' + (same_as ? ' mb-0' : '')}>Business Operation Address (includes online business)</h4>
                                <Controller
                                    name="address.same_as"
                                    control={control}
                                    defaultValue={false}
                                    render={(
                                        { onChange, onBlur, value, name, ref },
                                        { invalid, isTouched, isDirty }
                                    ) => (
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={value ? true : false}
                                                onChange={e => {
                                                    onChange(e.target.checked)
                                                }}
                                                id={'same_as_business_registration_info'}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={'same_as_business_registration_info'}
                                            >
                                                Same as Registration Information
                                            </label>
                                        </div>
                                    )}
                                />
                            </div>

                            {!same_as &&
                                <div>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="form-group">
                                                <label className="text-danger">Business Operating Address<sup>*</sup></label>
                                                <input
                                                    name="address.address" ref={register}
                                                    placeholder=""
                                                    className={'form-control' + (errors.address?.address ? ' is-invalid' : '')}
                                                />
                                                {errors.address?.address && <div className="invalid-feedback d-block">{errors.address?.address.message}</div>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>APT/Condo/Suit #</label>
                                                <input
                                                    name="address.suit" ref={register}
                                                    placeholder=""
                                                    className={'form-control' + (errors.address?.suit ? ' is-invalid' : '')}
                                                />
                                                {errors.address?.suit && <div className="invalid-feedback d-block">{errors.address.suit?.message}</div>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="form-group">
                                                <label className="text-danger">Location: City, State, Country, Province, Township or ?<sup>*</sup></label>
                                                <Controller
                                                    control={control}
                                                    name="address.location"
                                                    render={(
                                                        { onChange, onBlur, value, name, ref },
                                                        { invalid, isTouched, isDirty }
                                                    ) => (
                                                        <AsyncTypeahead
                                                            id="business-profile-location-id"
                                                            filterBy={() => true}
                                                            isLoading={loading}
                                                            labelKey={item => {
                                                                return [item.name, item.location.name, item.location.location.name].join(', ')
                                                            }}
                                                            onSearch={query => {
                                                                setLoading(true)
                                                                locationSearchCity(query).then(res => {
                                                                    setLocations(res)
                                                                    setLoading(false)
                                                                }).catch(() => setLoading(false))
                                                            }}

                                                            inputProps={{
                                                                className: 'form-control' + (errors.address?.location ? ' is-invalid' : ''),
                                                                placeholder: (value ? value.name : 'Type location name')
                                                            }}
                                                            onChange={selected => {
                                                                const location = selected[0]
                                                                if(location && location.id){
                                                                    onChange({
                                                                        id: location.id,
                                                                        name: [location.name, location.location?.name, location.location?.location?.name].filter(item => item).join(', ')
                                                                    })
                                                                }else{
                                                                    onChange(null)
                                                                }
                                                            }}
                                                            options={locations}
                                                        />
                                                    )}
                                                />
                                                {errors.address?.location && <div className="invalid-feedback d-block">{errors.address?.location.message}</div>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="text-danger">Zip Code<sup>*</sup></label>
                                                <input
                                                    placeholder=""
                                                    name="address.postal_code" ref={register}
                                                    className={'form-control' + (errors.address?.postal_code ? ' is-invalid' : '')}
                                                />
                                                {errors.address?.postal_code && <div className="invalid-feedback d-block">{errors.address?.postal_code.message}</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    <hr />

                    <div className="row">
                        <div className="col-md-6">
                            <h4 className="card-title">Operation Hours</h4>

                            <Controller
                                name="hours"
                                control={control}
                                defaultValue={null}
                                render={(
                                    { onChange, onBlur, value, name, ref },
                                    { invalid, isTouched, isDirty }
                                ) => (
                                    <div className="mb-3">
                                        {days.map(day => {
                                            return <OperationHoursItem
                                                key={day.day}
                                                day={day}
                                                item={value ? value.filter(item => item.day == day.day)[0] : null}
                                                onChange={newItem => {
                                                    let oldItem = value ? value.filter(item => item.day == newItem.day)[0] : null
                                                    if(!oldItem) oldItem = {}
                                                    const items = [...(value ? value.filter(item => item.day != newItem.day) : []), {...oldItem, ...newItem}]
                                                        .filter(item => !Array.isArray(item))
                                                    onChange(items)
                                                }}
                                            />
                                        })}
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-6">
                            <h4 className="card-title">Operation Hours Notes</h4>
                            <div className="form-group">
                                <label>For more information you can place directive not in this field.</label>
                                <textarea
                                    name="oh_notes"
                                    placeholder=""
                                    rows="5" ref={register}
                                    className={'form-control' + (errors.oh_notes ? ' is-invalid' : '')}
                                ></textarea>
                                {errors.oh_notes && <div className="invalid-feedback d-block">{errors.oh_notes.message}</div>}
                            </div>
                        </div>
                    </div>

                    <hr />

                    <LinksForm
                        links={company.links}
                        onSubmit={onSubmit}
                        title="Links for your business"
                    />

                    <div>
                        <button
                            className="btn btn-primary w-100 btn-lg"
                            type="submit"
                            disabled={submitting}
                        >Submit</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

const OperationHoursItem = ({ day, item, onChange }) => {

    const setItem = (type, value) => {
        let newItem = item
        if(newItem){
            newItem[type] = value
        }else{
            newItem = {day: day.day, label: day.label, [type]: value}
        }
        onChange(newItem)
    }

    return (
        <div className="d-flex mb-2">
            <div style={{width: '120px'}} className="d-flex justify-content-center flex-column">
                <h5 className="my-0 py-0">{day.label}</h5>
            </div>
            <div className="ms-4 me-2 d-flex flex-column justify-content-center">
                <div className="form-check">
                    <input
                        className="form-check-input me-2"
                        type="checkbox"
                        checked={item?.open ? item.open : false}
                        onChange={e => setItem('open', e.target.checked)}
                        id={'day_open_' + day.day}
                    />
                    <label
                        className="form-check-label"
                        htmlFor={'day_open_' + day.day}
                    >
                        Open
                    </label>
                </div>
            </div>
            {item?.open && <>
                <div className="mx-2">
                    <select
                        value={item ? item.from : ''}
                        className="form-select"
                        onChange={e => setItem('from', e.target.value)}
                    >
                        <option>- Opens At -</option>
                        <option value="24-hours">24 hours</option>
                        {times.map(item =>
                            <option key={item} value={item}>{item}</option>
                        )}
                    </select>
                </div>
                {item?.from != '24-hours' &&
                    <>
                        <div className="d-flex justify-content-center flex-column">
                            <span> &ndash; </span>
                        </div>
                        <div className="mx-2">
                            <select
                                value={item ? item.to : ''}
                                onChange={e => setItem('to', e.target.value)}
                                className="form-select"
                            >
                                <option>- Closes At -</option>
                                {times.map(item =>
                                    <option key={item} value={item}>{item}</option>
                                )}
                            </select>
                        </div>
                    </>
                }
            </>}
        </div>
    )
}

const ChangeProfileType = ({ onChange }) => {

    const { authServices, setAppState } = useContext(AppContext)
    const addToast = useToastContext()

    const [ loading, setLoading ] = useState(false)

    const mountedRef = useRef(true)

    useEffect(() => {
        return () => mountedRef.current = false
    }, [])

    const udpateUser = data => {
        setLoading(true)
        return authServices.update(data).then(res => {
            addToast({title: 'Success', message: 'Profile Type changed successfully!', type: 'success'})
            setAppState('app.user', res.user)
            onChange()
            if(mountedRef.current) setLoading(false)
        }).catch(res => {
            if(res.data){
                if(res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
            }
            if(mountedRef.current) setLoading(false)
        })
    }

    return (
        <div>
            <p className="lead">Your profile type is Personal Profile. </p>
            <div>
                <button
                    className="btn btn-primary"
                    onClick={() => udpateUser({profile_type: 1})}
                    disabled={loading}
                >
                    {!loading && 'Add business information'}
                    {loading && <FontAwesomeIcon icon={faSpinner} spin />}
                </button>
            </div>
        </div>
    )
}

const BusinessProfile = ({ match, history }) => {

    const { data, location } = useContext(AppContext)
    const { app } = data
    const { user } = app

    if(!user) return null

    const isBusinessProfile = user.profile_type == 1

    const { companyServices, setAppState } = useContext(AppContext)
    const addToast = useToastContext()

    const [ company, setCompany ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ submitting, setSubmitting ] = useState(false)

    const [ timestamp, setTimestamp ] = useState(new Date().getTime())

    const canSubmitCompany = company && company.name && company.phone && company.description ? true : false

    const title = "Business Profile"

    const loadData = () => {
        setLoading(true)
        companyServices.byUser().then(res => {
            if(res.company) setCompany(res.company)
            if(res.user) setAppState('app.user', res.user)
            setLoading(false)
        }).catch(err => {
            addToast({title: 'Error', message: err?.data?.message ? err.data.message : 'Something went wrong', type: 'danger'})
        })
    }

    const onSubmit = data => {
        return new Promise((resolve, reject) => {
            setSubmitting(true)
            return companyServices.update(company.id, data).then(res => {
                if(res.company) setCompany(res.company)
                setSubmitting(false)
                addToast({title: 'Success', message: 'Save/Update success', type: 'success'})
                resolve(res.company)
            }).catch(err => {
                setSubmitting(false)
                addToast({title: 'Error', message: err?.data?.message ? err.data.message : 'Something went wrong', type: 'danger'})
                reject(err?.data)
            })
        })
    }

    useEffect(() => {
        loadData()
    }, [ timestamp ])

    return (
        <>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">

                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {title}])} />

                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>

                        <div className="d-flex justify-content-between">

                            <h1>{title}</h1>

                            {!loading && company && isBusinessProfile &&
                                <div className="d-flex justify-content-center flex-column">
                                    <div className="d-flex">
                                        <div className="d-flex justify-content-center flex-column">
                                            {company.status_text &&
                                                <div className={' ' + (
                                                    [0].includes(company.status) ? 'text-secondary'
                                                    : [1].includes(company.status) ? 'text-primary'
                                                    : [2].includes(company.status) ? 'text-success'
                                                    : [3, 4].includes(company.status) ? 'text-danger'
                                                    : 'text-secondary'
                                                )}>
                                                    Status: {company.status_text}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        {loading &&
                            <div className="text-center my-5"><FontAwesomeIcon icon={faSpinner} spin /></div>
                        }

                        {(!loading && company && isBusinessProfile) ?
                            <BusinessProfileForm
                                company={company}
                                onSubmit={onSubmit}
                            />
                        : (
                            <>
                                {!loading && <ChangeProfileType onChange={loadData} />}
                            </>
                        )}
                    </div>
                </main>
            </div>
            <Footer />
        </>
    )
}

export default BusinessProfile
